import { editorialDashModuleQuery, useModule } from 'system/structure-modules';

export default function EditorialDashboardAdminsScreen() {
    const { AdminListTab } = useModule(editorialDashModuleQuery);
    return <AdminListTab />;
}
